import { render } from "./RecentSearchItem.vue?vue&type=template&id=3b1a33eb&scoped=true"
import script from "./RecentSearchItem.vue?vue&type=script&lang=js"
export * from "./RecentSearchItem.vue?vue&type=script&lang=js"

import "./RecentSearchItem.vue?vue&type=style&index=0&id=3b1a33eb&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1a33eb"]])

export default __exports__